import React from "react";
import dayjs from "dayjs";
import { arabicToNumber } from "@euroland/format-number";
import { replaceKey } from "./index";

export const AMOUNT_INVESTED_ERRORS = {
  REQUIRED: "required",
  MINIMUM_REQUIRED: "minimumRequired",
};

const buildMinimumRequiredMessage = (template, price, currencyLabel) => {
  if (!template.includes("{0}") || !template.includes("{1}")) {
    return replaceKey(template, [price, currencyLabel]);
  }

  const [beforePrice, afterPrice] = template.split("{0}");
  const [between, afterCurrency] = afterPrice.split("{1}");

  return (
    <>
      {beforePrice}
      {price}
      {between}
      <span className="currency-code">{currencyLabel}</span>
      {afterCurrency}
    </>
  );
};

export const resolveMinimumSharePrice = ({ initialPrice, endPrice, initialDate, endDate }) => {
  const initial = dayjs(initialDate);
  const end = dayjs(endDate);
  if (initial.isValid() && end.isValid() && (initial.isSame(end, "date") || initial.isAfter(end, "date"))) {
    return Number(endPrice) || 0;
  }
  return Number(initialPrice) || 0;
};

export const parseAmountInvested = (value, useLatinNumber = true) => {
  if (value === null || value === "" || typeof value === "undefined") return null;
  const raw = useLatinNumber ? String(value) : arabicToNumber(String(value));
  const parsed = Number(raw);
  return Number.isNaN(parsed) ? null : parsed;
};

export const validateAmountInvested = ({ amount, minimumPrice, submitted }) => {
  if (amount === null) {
    return submitted ? AMOUNT_INVESTED_ERRORS.REQUIRED : null;
  }
  if (minimumPrice > 0 && amount < minimumPrice) {
    return AMOUNT_INVESTED_ERRORS.MINIMUM_REQUIRED;
  }
  return null;
};

export const getAmountInvestedErrorMessage = (errorCode, { minimumPrice, currencyLabel, formatNumber, translate }) => {
  if (!errorCode) return "";
  if (errorCode === AMOUNT_INVESTED_ERRORS.REQUIRED) {
    return translate("fieldRequired");
  }
  if (errorCode === AMOUNT_INVESTED_ERRORS.MINIMUM_REQUIRED) {
    const template = translate("amountInvestedMinimumRequired");
    return buildMinimumRequiredMessage(template, formatNumber(minimumPrice), currencyLabel);
  }
  return "";
};
